import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/facebookPixel';

/**
 * Automatically tracks Facebook Pixel PageView on React Router page transitions
 */
const FacebookPixelTracker = () => {
    const { pathname, search } = useLocation();

    useEffect(() => {
        trackPageView();
    }, [pathname, search]);

    return null;
};

export default FacebookPixelTracker;
